import styled from 'styled-components';
import { Page } from 'components/molecules/page';

export const PageContent = styled(Page.Content)`
  > .ant-row {
    padding: var(--spacing-03);
  }
`;
